import React, { useState } from 'react';
import { Button, Alert, Box, CircularProgress } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../FirebaseAuth/firebase';
import { Refresh as RefreshIcon } from '@mui/icons-material';

/**
 * Refresh Organization Profile Button Component
 * Allows organization admins to refresh their organization's profile data
 */
const RefreshOrgProfileButton = ({ organizationId, currentUser, size = "small", variant = "outlined" }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [result, setResult] = useState('');
  const [error, setError] = useState('');

  // Only show to org admins and kwallAdmins
  if (!currentUser?.role?.includes('kwallAdmin') && !currentUser?.role?.includes('orgAdmin')) {
    return null;
  }

  const handleRefreshProfile = async () => {
    setIsRefreshing(true);
    setError('');
    setResult('');

    try {
      console.log('🔄 Starting profile refresh for org:', organizationId);
      const refreshOrgProfile = httpsCallable(CloudFunctions, 'orgProfileEnhancer-refreshOrganizationProfile');
      const response = await refreshOrgProfile({ orgId: organizationId });
      
      console.log('✅ Profile refresh response:', response.data);
      const summary = response.data.summary;
      setResult(`Profile refreshed! ${summary.totalAccounts} collections, ${summary.totalSites} sites, ${summary.totalDomains} domains${summary.hasDiffbotData ? ' + industry data' : ''}`);
      
      // Trigger a page reload to show new data
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error('❌ Error refreshing organization profile:', error);
      setError(error.message || 'Failed to refresh organization profile');
    }

    setIsRefreshing(false);
  };

  return (
    <Box>
      <Button
        variant={variant}
        color="info"
        onClick={handleRefreshProfile}
        disabled={isRefreshing}
        size={size}
        startIcon={isRefreshing ? <CircularProgress size={16} /> : <RefreshIcon />}
        sx={{
          borderColor: 'info.main',
          color: 'info.main',
          '&:hover': {
            borderColor: 'info.dark',
            backgroundColor: 'info.light'
          }
        }}
      >
        {isRefreshing ? 'Refreshing...' : 'Refresh Profile'}
      </Button>
      
      {error && (
        <Alert severity="error" sx={{ mt: 1, fontSize: '0.8rem' }}>
          {error}
        </Alert>
      )}
      
      {result && (
        <Alert severity="success" sx={{ mt: 1, fontSize: '0.8rem' }}>
          {result}
        </Alert>
      )}
    </Box>
  );
};

export default RefreshOrgProfileButton;